<template>
  <li :class="{
    [className]: Boolean(className),
    valid: isValid === true,
    invalid: isValid === false,
    neutral: isValid === null,
  }">
    <SuccessIcon v-if="isValid === true" class="icon" />
    <ErrorIcon v-if="isValid === false" class="icon" />
    <slot></slot>
  </li>
</template>

<script>
import { ErrorIcon, SuccessIcon } from '@components/icons'

export default {
  name: 'PasswordRequirementRow',
  components: { SuccessIcon, ErrorIcon },
  props: {
    isValid: {
      type: [Boolean, null],
      default: null
    },
    className: String
  }
}
</script>

<style scoped lang="scss">
li {
  padding-left: 30px;
  position: relative;
  list-style: none;

  &::marker {
    display: none;
  }

  &::before {
    content: "•";
    position: absolute;
    left: 0;
    display: inline-block;
    width: 30px;
    text-align: center;
  }

  &.valid::before, &.invalid::before {
    content: "";
  }

  // For neutral state (null), show bullet but no icon
  &.neutral::before {
    content: "•";
  }

  &.neutral .icon {
    display: none;
  }

  .icon {
    position: absolute;
    top: 3px;
    left: 0;
    width: 30px;
    text-align: center;
  }
}
</style>
